import { Group, Tooltip } from '@mantine/core';
import { IconArrowRight, IconTrash } from '@tabler/icons-react';
import { ChastiaConfigForm, ChastiaSpecialFieldPairing } from 'components/forms/remote-source/config/types';
import { EvidenceFieldSelect } from 'components/selects/EvidenceFieldSelect';
import { useCallback } from 'react';
import { useConfirm } from 'components/modals/message/MessageProvider';
import ActionIcon from 'components/ActionIcon';
import SpecialFieldSourceSelect from 'components/forms/remote-source/config/chastia-config-form/special-fields/SpecialFieldSourceSelect';

interface SpecialFieldPairingRowProps {
  form: ChastiaConfigForm;
  item: ChastiaSpecialFieldPairing;
  index: number;
}

/**
 * A single row for Chastia special field pairings.
 */
export default function SpecialFieldPairingRow({ form, item, index }: SpecialFieldPairingRowProps) {
  const { confirm } = useConfirm();

  const removeRow = useCallback(() => {
    if (!item.source && !item.evidenceFieldId) {
      form.removeListItem('specialFields', index);
    } else {
      confirm({
        title: 'Odstrániť riadok?',
        content: 'Naozaj chcete odstrániť tento riadok mapovania špeciálnych polí?',
        onConfirm: () => form.removeListItem('specialFields', index),
      });
    }
  }, [confirm, form, item, index]);

  return (
    <Group key={item.key} className="grid max-w-[972px] grid-cols-[1fr_24px_1fr_44px] items-center gap-y-0">
      <SpecialFieldSourceSelect size="md" {...form.getInputProps(`specialFields.${index}.source`)} />
      <IconArrowRight stroke={1.5} />
      <EvidenceFieldSelect
        applicability="devices"
        size="md"
        placeholder="Vybrať evidenčné pole"
        {...form.getInputProps(`specialFields.${index}.evidenceFieldId`)}
      />
      <Group spacing={8} noWrap>
        <Tooltip label="Odstrániť riadok" openDelay={500} withArrow={false}>
          <ActionIcon variant="subtle" size="md" onClick={removeRow}>
            <IconTrash />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Group>
  );
}
